export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  image: string;
}

export const services: Service[] = [
  {
    id: '1',
    title: '专业体育培训',
    description: '覆盖篮球、足球、游泳、羽毛球、网球等十余项运动，拥有50+持证专业教练，为各年龄段学员提供系统化培训课程。',
    icon: 'ri-user-star-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20coach%20training%20athlete%20in%20modern%20gym%2C%20warm%20lighting%2C%20dynamic%20pose%2C%20clean%20minimalist%20style%2C%20sporty%20orange%20and%20cream%20tones&width=600&height=400&seq=yunkai-svc-1&orientation=landscape',
  },
  {
    id: '2',
    title: '赛事全程运营',
    description: '从策划到执行，提供赛事全流程管理服务。累计承办超过200场各类体育赛事，覆盖社区联赛、企业赛事、校际比赛等。',
    icon: 'ri-flag-line',
    image: 'https://readdy.ai/api/search-image?query=Sports%20event%20management%20team%20coordinating%20competition%20in%20arena%2C%20professional%20atmosphere%2C%20warm%20lighting%2C%20organized%20scene%2C%20clean%20aesthetic&width=600&height=400&seq=yunkai-svc-2&orientation=landscape',
  },
  {
    id: '3',
    title: '优质运动装备',
    description: '与国内外知名品牌深度合作，提供正品运动装备和专业选购建议。支持企业团购定制和个人个性化推荐服务。',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20equipment%20and%20apparel%20neatly%20arranged%20on%20minimalist%20display%2C%20warm%20cream%20background%2C%20clean%20product%20photography%2C%20professional%20retail%20style&width=600&height=400&seq=yunkai-svc-3&orientation=landscape',
  },
  {
    id: '4',
    title: '智能场馆管理',
    description: '自主研发的智能场馆管理系统，支持在线预约、会员管理、数据分析和设备监控，帮您实现场馆运营数字化升级。',
    icon: 'ri-smartphone-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20sports%20facility%20with%20digital%20booking%20screen%20and%20clean%20interior%2C%20smart%20venue%20management%2C%20warm%20lighting%2C%20minimalist%20design%2C%20technology%20and%20sports%20fusion&width=600&height=400&seq=yunkai-svc-4&orientation=landscape',
  },
];